import * as React from "react";
import type { SVGProps } from "react";
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#list_svg__a)">
      <path d="M21 7H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M21 13H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M21 19H7c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1M3 7c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.84.84 0 0 1 2 6c0-.13.02-.26.08-.38q.075-.18.21-.33c.24-.23.58-.34.91-.27q.09.015.18.06.09.03.18.09l.15.12q.135.15.21.33c.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.05.04-.1.09-.15.12q-.09.06-.18.09-.09.045-.18.06c-.07.01-.13.02-.2.02M3 13c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.84.84 0 0 1 2 12c0-.13.02-.26.08-.38q.075-.18.21-.33c.24-.23.58-.34.91-.27q.09.015.18.06.09.03.18.09l.15.12q.135.15.21.33c.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.05.04-.1.09-.15.12q-.09.06-.18.09-.09.045-.18.06c-.07.01-.13.02-.2.02M3 19c-.26 0-.52-.11-.71-.29-.09-.1-.16-.2-.21-.33A.84.84 0 0 1 2 18c0-.13.02-.26.08-.38q.075-.18.21-.33c.24-.23.58-.34.91-.27q.09.015.18.06.09.03.18.09l.15.12q.135.15.21.33c.06.12.08.25.08.38s-.02.26-.08.38c-.05.13-.12.23-.21.33-.05.04-.1.09-.15.12q-.09.06-.18.09-.09.045-.18.06c-.07.01-.13.02-.2.02" />
    </g>
    <defs>
      <clipPath id="list_svg__a">
        <path fill="#fff" d="M2 5h20v14H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgList;
